'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weeksBefore.js
// module id = 754
// module chunks = 0